<template>
  <div>
    <vxe-card>
      <template #title>
        <vxe-input v-model="query['item.no']" placeholder="placeholder.itemNo" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="query['item.name']" placeholder="placeholder.itemName" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="query['lot.no']" placeholder="placeholder.lotNo" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-input v-model="query['location.no']" placeholder="placeholder.location" @clear="refresh" @keydown.native.enter="refresh"/>
        <vxe-date-range-picker v-model="query.range" clearable linked-panels placeholder="business.label.addTime" type="date" @change="refresh"/>
      </template>
      <template #extra>
        <vxe-button content="button.query" icon="vxe-icon-search" status="primary" @click="refresh"/>
        <vxe-button content="button.reset" icon="vxe-icon-undo" status="danger" @click="reset"/>
      </template>
      <vxe-table ref="table" :data="data" :loading="loading">
        <vxe-column fixed="left" type="seq" width="40"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="maintenance.executed" title="business.label.executed" width="70"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="maintenance.important" title="business.label.important" width="70"/>
        <vxe-column field="item.no" title="business.label.itemNo" width="80"/>
        <vxe-column field="item.name" title="business.label.itemName"/>
        <vxe-column field="pack.specification" title="business.label.specification"/>
        <vxe-column field="pack.factor" title="business.label.factor" width="60"/>
        <vxe-column field="pack.uom" title="business.label.uom" width="60"/>
        <vxe-column field="lot.no" title="business.label.lotNo"/>
        <vxe-column field="lot.manufacturer" title="business.label.manufacturer"/>
        <vxe-column field="location.no" title="business.label.location"/>
        <vxe-column field="storageRoom.name" title="business.label.storageRoom"/>
        <vxe-column field="maintenance.inventoryQuantity" title="business.label.invQuantity"/>
        <vxe-column field="maintenance.quantity" title="span.maintenanceQuantity"/>
        <vxe-column :cell-render="{name:'FormatSelect',options:maintenanceWays}" field="maintenance.maintenanceWay" title="span.maintenanceMeasure"/>
        <vxe-column field="maintenance.notes" title="span.maintenanceAdvice"/>
      </vxe-table>
      <template #footer>
        <vxe-pager :current-page="page" :loading="loading" :page-size="size" :total="contentSize" @page-change="pageChange"/>
      </template>
    </vxe-card>
  </div>
</template>

<script>
import { findAll } from '@/api/Api'
import moment from 'moment/moment'
import { getEnums } from '@/utils/util'

export default {
  name: 'MaintenanceQuery',
  data() {
    return {
      loading: false,
      data: [],
      query: {
        'item.no': '',
        'item.name': '',
        'lot.no': '',
        'location.no': '',
        range: [moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')]
      },
      maintenanceWays: [],
      page: 1,
      size: 20,
      contentSize: 0
    }
  },
  created() {
    getEnums('MaintenanceWay').then(result => {
      this.maintenanceWays = result
    })
  },
  methods: {
    moment,
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.fetch()
    },
    fetch() {
      this.loading = true
      const args = Object.assign({}, this.query)
      if (args.range.length > 0) {
        args['editDateFilter'] = { start: args.range[0], end: args.range[1] }
      } else {
        args['editDateFilter'] = null
      }
      findAll('maintenanceFactory', args, this.page, this.size).then(res => {
        if (res.success) {
          this.data = res.result
          this.contentSize = res.contentSize
        }
      }).finally(() => this.loading = false)
    },
    refresh() {
      this.page = 1
      this.fetch()
    },
    reset() {
      this.query = {
        'item.no': '',
        'item.name': '',
        'lot.no': '',
        'location.no': '',
        range: [moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')]
      }
      this.refresh()
    }
  }
}
</script>